import React from 'react';
import { Link } from 'react-router-dom';

const AboutCTA = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-indigo-600 to-purple-600">
      <div className="container mx-auto px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-block p-3 bg-indigo-500 bg-opacity-30 rounded-lg mb-6">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
            </svg>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Müzik Tutkunu Musun?</h2>
          <p className="text-lg text-indigo-100 mb-8">
            İYTE Müzik Topluluğu'na katılarak tutkunu paylaş, etkinliklerimize katıl ve kampüs hayatını müzikle doldur.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/register" className="px-8 py-3 bg-white text-indigo-600 font-medium rounded-lg shadow-lg hover:bg-indigo-50 transition-colors duration-300">
              Hemen Üye Ol
            </Link>
            <Link to="/contact" className="px-8 py-3 bg-transparent text-white font-medium border-2 border-white rounded-lg hover:bg-white hover:bg-opacity-10 transition-colors duration-300">
              Bize Ulaşın
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCTA;